import { Image } from '@/component/Image';
import { MyCarousel } from '@/component/MyCarousel';

import styles from './CardCarousel.module.css';
import { Link } from '@/i18n/routing';

export const CardCarousel = ({ previewImages, cardUrl }) => {
  return (
    <>
      {!!previewImages?.length ? (
        <MyCarousel
          classWrap="sm:h-[272px] cursor-pointer"
          images={previewImages.slice(0, 3)}
          dataTestId="card-carousel"
          url={cardUrl}
        />
      ) : (
        <Link {...cardUrl} prefetch={false}>
          <Image
            src="https://guestit-web-assets.s3-accelerate.amazonaws.com/images/icons/guestit_dummy_image.webp"
            className={styles.dummy_img}
            alt="no image"
            height={270}
            width={400}
            style={{ width: 'auto' }}
          />
        </Link>
      )}
    </>
  );
};
